export default __webpack_public_path__ + "static/media/diamond-cut-3@2x.d4456c67.png";